var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "columns pt-0 pb-0 mt-0 mb-0 is-vcentered" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "column pt-0 pb-0" }, [
          _c(
            "div",
            {
              staticClass:
                "columns is-multiline mt-0 mb-0 is-vcentered is-variable is-1 is-mobile",
            },
            [
              _vm.filterVisibility.search
                ? _c("div", { staticClass: "column is-narrow pt-1 pb-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm._search,
                          expression: "_search",
                        },
                      ],
                      staticClass: "input is-medium",
                      attrs: { type: "text", placeholder: "Suchen" },
                      domProps: { value: _vm._search },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm._search = $event.target.value
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.filterVisibility.tripName
                ? _c("div", { staticClass: "column is-narrow pt-1 pb-1" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filters.tripName,
                          expression: "filters.tripName",
                        },
                      ],
                      staticClass: "input is-medium is-hidden-on-small",
                      attrs: {
                        type: "text",
                        placeholder: "Reisetitel oder ResaNr suchen",
                      },
                      domProps: { value: _vm.filters.tripName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.filters, "tripName", $event.target.value)
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.filterVisibility.destinations
                ? _c(
                    "div",
                    { staticClass: "column is-narrow pt-1 pb-1" },
                    [
                      _c("async-select", {
                        staticClass: "is-smaller is-shorter",
                        attrs: {
                          api: "destinations",
                          placeholder: "Destinationen",
                          multiple: "",
                          "init-search": "",
                          compact: "",
                          "compact-label": ["Destination", "Destinationen"],
                        },
                        model: {
                          value: _vm.filters.destinations,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "destinations", $$v)
                          },
                          expression: "filters.destinations",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterVisibility.country
                ? _c(
                    "div",
                    { staticClass: "column is-narrow pt-1 pb-1" },
                    [
                      _c(
                        "multiselect",
                        {
                          staticClass:
                            "is-smaller is-hidden-on-small is-shorter",
                          attrs: {
                            "track-by": "label",
                            label: "name",
                            options: _vm.resources.countries,
                            placeholder: "Land",
                          },
                          model: {
                            value: _vm.filterCountry,
                            callback: function ($$v) {
                              _vm.filterCountry = $$v
                            },
                            expression: "filterCountry",
                          },
                        },
                        [
                          !!_vm.filterCountry
                            ? _c("div", {
                                staticClass: "multiselect__clear",
                                attrs: { slot: "clear" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    _vm.filterCountry = ""
                                  },
                                },
                                slot: "clear",
                              })
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterVisibility.orderStatus
                ? [
                    _c(
                      "div",
                      { staticClass: "column is-narrow pt-1 pb-1 pr-0" },
                      [
                        _c("color-switch", {
                          on: { input: _vm.setOrderStatus },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "column is-narrow pt-1 pb-1 pl-0" },
                      [
                        _c("multiselect", {
                          staticClass: "is-smaller is-shorter",
                          attrs: {
                            compact: "",
                            "compact-label": ["Status", "Stati"],
                            options: _vm.options.orderStatus
                              ? _vm.options.orderStatus
                              : [],
                            "track-by": "key",
                            label: "value",
                            multiple: "",
                            placeholder: "Status filtern",
                          },
                          model: {
                            value: _vm.orderStatus,
                            callback: function ($$v) {
                              _vm.orderStatus = $$v
                            },
                            expression: "orderStatus",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.filterVisibility.dateRange
                ? _c("div", { staticClass: "column is-narrow pt-1 pb-1" }, [
                    _c(
                      "div",
                      { staticClass: "flatpickr-combined" },
                      [
                        _c("input-date", {
                          model: {
                            value: _vm.filters.startAt,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "startAt", $$v)
                            },
                            expression: "filters.startAt",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("-")]),
                        _vm._v(" "),
                        _c("input-date", {
                          model: {
                            value: _vm.filters.endAt,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "endAt", $$v)
                            },
                            expression: "filters.endAt",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.filterVisibility.organisation &&
              _vm.resources.organisations.length > 1
                ? _c(
                    "div",
                    { staticClass: "column is-narrow pt-1 pb-1" },
                    [
                      _c(
                        "multiselect",
                        {
                          staticClass: "is-smaller is-shorter",
                          attrs: {
                            options: _vm.resources.organisations,
                            "track-by": "id",
                            label: "name",
                            placeholder: "Organisation",
                          },
                          model: {
                            value: _vm.filterOrganisation,
                            callback: function ($$v) {
                              _vm.filterOrganisation = $$v
                            },
                            expression: "filterOrganisation",
                          },
                        },
                        [
                          !!_vm.filterOrganisation
                            ? _c("div", {
                                staticClass: "multiselect__clear",
                                attrs: { slot: "clear" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    _vm.filterOrganisation = ""
                                  },
                                },
                                slot: "clear",
                              })
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterVisibility.requestSource
                ? _c(
                    "div",
                    { staticClass: "column is-narrow pt-1 pb-1" },
                    [
                      _c("multiselect", {
                        staticClass: "is-smaller is-shorter",
                        attrs: {
                          compact: "",
                          "compact-label": ["Anfragequelle", "Anfragequellen"],
                          options:
                            _vm.options && _vm.options.requestSourceList
                              ? _vm.options.requestSourceList
                              : [],
                          "track-by": "key",
                          label: "value",
                          multiple: "",
                          placeholder: "Anfragequelle",
                        },
                        model: {
                          value: _vm.requestSource,
                          callback: function ($$v) {
                            _vm.requestSource = $$v
                          },
                          expression: "requestSource",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterVisibility.mainLanguage
                ? _c(
                    "div",
                    { staticClass: "column is-narrow pt-1 pb-1" },
                    [
                      _c("multiselect", {
                        staticClass: "is-smaller is-shorter",
                        attrs: {
                          compact: "",
                          "compact-label": ["Sprache", "Sprachen"],
                          options:
                            _vm.options && _vm.options.mainLanguage
                              ? _vm.options.mainLanguage
                              : [],
                          "track-by": "key",
                          label: "value",
                          multiple: "",
                          placeholder: "Kundensprache",
                        },
                        model: {
                          value: _vm.clientMainLanguage,
                          callback: function ($$v) {
                            _vm.clientMainLanguage = $$v
                          },
                          expression: "clientMainLanguage",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.filterVisibility.tags
                ? _c(
                    "div",
                    { staticClass: "column is-narrow pt-1 pb-1" },
                    [
                      _c(
                        "multiselect",
                        {
                          staticClass: "is-small is-shorter",
                          attrs: {
                            compact: "",
                            options:
                              _vm.options && _vm.options.orderTags
                                ? _vm.options.orderTags
                                : [],
                            taggable: true,
                            multiple: "",
                            placeholder: "Tags",
                          },
                          on: { tag: _vm.addTag },
                          model: {
                            value: _vm.filterTags,
                            callback: function ($$v) {
                              _vm.filterTags = $$v
                            },
                            expression: "filterTags",
                          },
                        },
                        [
                          _c("span", {
                            attrs: { slot: "caret" },
                            slot: "caret",
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "column is-narrow pt-1 pb-1" }, [
                _c(
                  "button",
                  {
                    staticClass: "button filter-settings-btn",
                    attrs: { title: "Filter konfigurieren" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.showSettingsModal = true
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("settings"),
                    ]),
                  ]
                ),
              ]),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            visible: _vm.showSettingsModal,
            classes: "filter-settings-modal",
          },
          on: {
            closeModal: function ($event) {
              _vm.showSettingsModal = false
            },
          },
        },
        [
          _c("template", { slot: "header" }, [_vm._v("Filter konfigurieren")]),
          _vm._v(" "),
          _c("template", { slot: "content" }, [
            _c("p", { staticClass: "mb-3" }, [
              _vm._v("Filter ein- oder ausblenden:"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-settings-list" },
              _vm._l(_vm.filterLabels, function (label, key) {
                return _c(
                  "label",
                  { key: key, staticClass: "filter-settings-item" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filterVisibility[key],
                          expression: "filterVisibility[key]",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.filterVisibility[key])
                          ? _vm._i(_vm.filterVisibility[key], null) > -1
                          : _vm.filterVisibility[key],
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.filterVisibility[key],
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.filterVisibility,
                                  key,
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.filterVisibility,
                                  key,
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.filterVisibility, key, $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(label))]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.showSettingsModal = false
                  },
                },
              },
              [_vm._v("Schließen")]
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-narrow pt-1 pb-1" }, [
      _c("i", { staticClass: "fa fa-filter fa-lg" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }